module.exports = __webpack_public_path__ + "static/img/bg_console.c4ecc7d1.jpg";